import ApiOperation from "adapter/ApiOperation";
import Constants from "utils/Constants";

const factory = {
    getListWarehouseIn: (payload) => {

        let params = {
            subAttribute: ""
        };

        let data = {
            subAttribute: {}
        }

        if (payload[Constants.QueryParams.SEARCH.VALUE]) {
            params['keyword'] = payload[Constants.QueryParams.SEARCH.VALUE];
        }

        if (payload[Constants.QueryParams.OFFSET.VALUE]) {
            params['page'] = payload[Constants.QueryParams.OFFSET.VALUE];
        } else {
            params['page'] = 1;
        }

        if (payload[Constants.QueryParams.LIMIT.VALUE]) {
            params['limit'] = payload[Constants.QueryParams.LIMIT.VALUE];
        } else {
            params['limit'] = Constants.PAGINATION.LIMIT;
        }

        if (payload[Constants.QueryParams.ATTRIBUTES.VALUE]) {
            data['mainAttribute'] = JSON.parse(payload[Constants.QueryParams.ATTRIBUTES.VALUE]);
        }

        let url = `/rest/api/v1/management/warehouse/filter`;
        return ApiOperation.request({
            url: url,
            method: 'POST',
            params: params,
            data: data
        })
    },
    getHolonTemplateDetail: () => {
        let url = `/rest/api/v1/management/warehouse/template`;
        return ApiOperation.request({
            url: url,
            method: 'GET',
        })
    },
    creationWarehouseIn: (payload) => {
        let url = `/rest/api/v1/management/warehouse-in`;
        return ApiOperation.request({
            url: url,
            method: 'POST',
            data: payload
        })
    },
    creationWarehouseOut: (payload) => {
        let url = `/rest/api/v1/management/warehouse-out`;
        return ApiOperation.request({
            url: url,
            method: 'POST',
            data: payload
        })
    },
    getDataInBarcode: (payload) => {
        let url = `/rest/api/v1/management/warehouse-in/search`;
        return ApiOperation.request({
            url: url,
            method: 'GET',
            params: {
                keyword: payload
            }
        })
    },
    getDataInBarcodeWarehouseOut: (payload) => {
        let url = `/rest/api/v1/management/warehouse-out/search`;
        return ApiOperation.request({
            url: url,
            method: 'GET',
            params: {
                keyword: payload
            }
        })
    },
}

export default factory;